module.exports = __webpack_public_path__ + "static/media/box.028e197a.svg";